import {
  formatCrosshairTime,
  formatTickMark,
  formatPriceValue,
} from "./lightweightChartUtils";
import { getChartPalette } from "./chartPalette";

export const buildChartOptions = ({ library, scale, assetType, isMobile }) => {
  const palette = getChartPalette();
  const isHighTimeframe =
    scale === "1d" || scale === "1w" || scale === "1mo";

  return {
    layout: {
      background: { color: palette.background },
      textColor: palette.text,
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    },
    attributionLogo: { visible: false },
    grid: {
      vertLines: { color: palette.grid },
      horzLines: { color: palette.grid },
    },
    crosshair: {
      mode: library?.CrosshairMode?.Normal ?? 0,
      vertLine: {
        color: palette.crosshair,
        width: 1,
        style: 2,
      },
      horzLine: {
        color: palette.crosshair,
        width: 1,
        style: 2,
      },
    },
    rightPriceScale: {
      borderColor: palette.border,
      scaleMargins: { top: 0.08, bottom: 0.08 },
    },
    leftPriceScale: {
      visible: false,
    },
    timeScale: {
      borderColor: palette.border,
      timeVisible: !isHighTimeframe,
      secondsVisible: false,
      rightOffset: 5,
      rightBarStaysOnScroll: true,
      barSpacing: isMobile ? 5.6 : 7,
      minBarSpacing: 3,
      tickMarkFormatter: (time) => formatTickMark(time, scale),
    },
    handleScroll: isMobile
      ? {
          mouseWheel: false,
          pressedMouseMove: false,
          horzTouchDrag: true,
          vertTouchDrag: false,
        }
      : {
          mouseWheel: true,
          pressedMouseMove: true,
          horzTouchDrag: true,
          vertTouchDrag: false,
        },
    handleScale: isMobile
      ? {
          mouseWheel: false,
          axisPressedMouseMove: false,
          pinch: true,
        }
      : {
          mouseWheel: true,
          axisPressedMouseMove: true,
          pinch: true,
        },
    localization: {
      timeFormatter: (time) => formatCrosshairTime(time, scale),
      priceFormatter: (value) => formatPriceValue(value, assetType),
    },
  };
};
